export default function cleanMetaForErrorReporting(metaObj) {
    const { nav, breadcrumbs, hideBackTitleBar, theme, speedMode, ...others } = metaObj;

    const out = {};
    for (const [key, value] of Object.entries(others)) {
        if (key.indexOf('url') !== 0) {
            out[key] = value;
        }
    }

    return out;
}
